import { useEffect } from "react";
import { useLocation } from "react-router";
import ErrorPage from "@/shared/components/ErrorPage/ErrorPage";
import { captureMessage } from "@/shared/services/sentry.service";
import { classifyRouteNotFound } from "@/shared/utils/sentryNoise";

// Kept apart from ErrorPage: FeatureProtectedRoute also renders it for feature gating,
// which is not an unmatched route and must not be reported.
const RouteNotFoundPage = () => {
  const { key, pathname } = useLocation();

  useEffect(() => {
    const {
      message, level, tags, fingerprint,
    } = classifyRouteNotFound(key, pathname);
    captureMessage(message, { level, tags, fingerprint });
  }, [key, pathname]);

  return <ErrorPage />;
};

export default RouteNotFoundPage;
